/* eslint-disable */

import React, {useState} from 'react'
import 'antd/dist/antd.min.css'
import {Button, Collapse, DatePicker, Form, Input, InputNumber, Switch, TimePicker,} from 'antd'
import {useTranslation} from 'react-i18next'
import moment from 'moment'
import localeRU from 'antd/es/date-picker/locale/ru_RU'
import localeEN from 'antd/es/date-picker/locale/en_GB'
import localeES from 'antd/es/date-picker/locale/es_ES'
import TrendConstraint from "../../../components/TrendConstraint";
import {observer} from "mobx-react-lite";
import {useStore} from "../../../../../../../../../../../../../hooks/useStore";

const {TextArea} = Input
const formatDate = 'YYYY-MM-DD'
const {Panel} = Collapse

const TrendData = observer(({warningId, warningData}) => {
    const {commonTrendParameterConstraintsStore} = useStore();

    const {t} = useTranslation();
    const storageTranslations = JSON.parse(
        sessionStorage.getItem("translations")
    );

    const [buttonText, setButtonText] = useState(t("apply"));

    const chooseTranslateFromArray = (id, array, lang) => {
        const translationIndex =
            array &&
            array[lang] &&
            array[lang].findIndex((x) => x.parameterId === id);
        const parameterIndex =
            array &&
            array?.parameters &&
            array?.parameters.findIndex((x) => x.id === id);

        if (translationIndex >= 0) {
            return array[lang][translationIndex].translation
                ? array[lang][translationIndex].translation
                : array?.parameters[parameterIndex].alias;
        }

        return parameterIndex >= 0 ? array?.parameters[parameterIndex].alias : id;
    };

    const onFinish = async values => {
        values.trendSettingsIndividual.warningId = warningId
        await commonTrendParameterConstraintsStore.updateTrendIndividualAnalysisSettings(warningData?.trendGroupName, warningData?.trendConstraints, warningData?.wellId, values.trendSettingsIndividual)
        setButtonText(t("applied"));
    }

    const {i18n} = useTranslation()
    const currentLanguage = i18n.language

    let locale = ''

    moment.locale('ru')
    switch (currentLanguage) {
        case 'ru': {
            locale = localeRU
            moment.locale('ru')
            break
        }
        case 'en': {
            locale = localeEN
            moment.locale('en-gb')
            break
        }
        case 'es': {
            locale = localeES
            moment.locale('es')
            break
        }
        default: {
            locale = localeRU
            moment.locale('ru')
            break
        }
    }

    const layout = {
        labelCol: {
            span: 14,
        },
        wrapperCol: {
            span: 12,
        },
    }

    return (
        <Form
            {...layout}
            name="nest-messages"
            onFinish={onFinish}
            className
            onValuesChange={() => setButtonText(t("apply"))}
        >
            <Form.Item initialValue={warningData?.status}
                       name={['trendSettingsIndividual', 'status']}
                       valuePropName="checked"
                       label="Индивидуальные настройки ВКЛ/ВЫКЛ"
                       labelAlign="left"
                       wrapperCol={{
                           offset: 0,
                           span: 16,
                       }}
            >
                <Switch/>
            </Form.Item>
            <Form.Item initialValue={warningData?.state}
                       name={['trendSettingsIndividual', 'state']}
                       valuePropName="checked"
                       label="Статус"
                       labelAlign="left"
                       wrapperCol={{
                           offset: 0,
                           span: 16,
                       }}
            >
                <Switch/>
            </Form.Item>
            <Form.Item initialValue={moment.utc(warningData.analysisTime, "HH:mm:ss").local()} labelAlign="left"
                       label={'Время последнего анализа'}
                       name={['trendSettingsIndividual', 'analysisTime']}>
                <TimePicker locale={locale}/>
            </Form.Item>
            <Form.Item labelAlign="left" label="Отсрочка срабатывания"
                       rules={[{required: false, message: 'Введите интервал'}]}>
                <Form.Item initialValue={warningData?.delayResponse.day} noStyle
                           name={['trendSettingsIndividual', 'delayResponseDays']}
                           rules={[{required: false, message: 'Введите сутки интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={365}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortDays')} </span>
                <Form.Item initialValue={warningData?.delayResponse.hour} noStyle
                           name={['trendSettingsIndividual', 'delayResponseHours']}
                           rules={[{required: false, message: 'Введите часы интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={23}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortHours')} </span>
            </Form.Item>

            <Form.Item labelAlign="left" label="Минимальный период"
                       rules={[{required: false, message: 'Введите интервал'}]}>
                <Form.Item initialValue={warningData?.analysisPeriodMin.day} noStyle
                           name={['trendSettingsIndividual', 'analysisPeriodMinDays']}
                           rules={[{required: false, message: 'Введите сутки интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={365}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortDays')} </span>
                <Form.Item initialValue={warningData?.analysisPeriodMin.hour} noStyle
                           name={['trendSettingsIndividual', 'analysisPeriodMinHours']}
                           rules={[{required: false, message: 'Введите часы интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={23}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortHours')} </span>
            </Form.Item>

            <Form.Item labelAlign="left" label="Максимальный период"
                       rules={[{required: false, message: 'Введите интервал'}]}>
                <Form.Item initialValue={warningData?.analysisPeriodMax.day} noStyle
                           name={['trendSettingsIndividual', 'analysisPeriodMaxDays']}
                           rules={[{required: false, message: 'Введите сутки интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={365}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortDays')} </span>
                <Form.Item initialValue={warningData?.analysisPeriodMax.hour} noStyle
                           name={['trendSettingsIndividual', 'analysisPeriodMaxHours']}
                           rules={[{required: false, message: 'Введите часы интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={23}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortHours')} </span>
            </Form.Item>

            <Form.Item labelAlign="left" label="Минимальная частота данных"
                       rules={[{required: false, message: 'Введите интервал'}]}>
                <Form.Item initialValue={warningData?.minDataFrequency.day} noStyle
                           name={['trendSettingsIndividual', 'minDataFrequencyDays']}
                           rules={[{required: false, message: 'Введите сутки интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={365}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortDays')} </span>
                <Form.Item initialValue={warningData?.minDataFrequency.hour} noStyle
                           name={['trendSettingsIndividual', 'minDataFrequencyHours']}
                           rules={[{required: false, message: 'Введите часы интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={23}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortHours')} </span>
            </Form.Item>

            <Form.Item labelAlign="left" label="Дискретность анализа"
                       rules={[{required: false, message: 'Введите интервал'}]}>
                <Form.Item initialValue={warningData?.timeDiscr.day} noStyle
                           name={['trendSettingsIndividual', 'timeDiscrDays']}
                           rules={[{required: false, message: 'Введите сутки интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={365}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortDays')} </span>
                <Form.Item initialValue={warningData?.timeDiscr.hour} noStyle
                           name={['trendSettingsIndividual', 'timeDiscrHours']}
                           rules={[{required: false, message: 'Введите часы интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={23}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortHours')} </span>
            </Form.Item>

            <Form.Item labelAlign="left" label="Межотчистной период"
                       rules={[{required: false, message: 'Введите интервал'}]}>
                <Form.Item initialValue={warningData?.mop.day} noStyle
                           name={['trendSettingsIndividual', 'mopDays']}
                           rules={[{required: false, message: 'Введите сутки интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={365}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>

                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortDays')} </span>
                <Form.Item initialValue={warningData?.mop.hour} noStyle
                           name={['trendSettingsIndividual', 'mopHours']}
                           rules={[{required: false, message: 'Введите часы интервала'}]}
                >
                    <InputNumber
                        min={0}
                        max={23}
                        style={{
                            width: '30%',
                        }}
                    />
                </Form.Item>
                <span className="ant-form-text" style={{paddingLeft: '5px'}}> {t('shortHours')} </span>
            </Form.Item>

            <Form.Item initialValue={moment(new Date(warningData?.lastMopDate), formatDate)} labelAlign="left"
                       label={'Дата последней депарафинизации'}
                       name={['trendSettingsIndividual', 'lastMopDate']}>
                <DatePicker locale={locale}/>
            </Form.Item>

            <Form.Item initialValue={warningData?.unapprovalReason} labelAlign="left" label={t('comment')}
                       name={['trendSettingsIndividual', 'unapprovalReason']}>
                <TextArea
                    label={t('unapprovalReason')}
                    rows={3}
                    cols={10}
                    maxLength={100}
                    rules={[{required: false, message: t('missingComment')}]}
                />
            </Form.Item>

            <div style={{paddingLeft: '20px'}}>
                <Collapse accordion ghost>
                    {warningData?.trendConstraints.map(trendConstraint =>
                        <Panel key={trendConstraint.parameterId}
                               header={`Предупреждение параметр = ${chooseTranslateFromArray(
                                   trendConstraint.parameterId,
                                   storageTranslations,
                                   currentLanguage
                               )}`}>
                            <TrendConstraint
                                approxConstraintsFirst={trendConstraint.approxConstraintsFirst}
                                approxConstraintsLast={trendConstraint.approxConstraintsLast}
                                deltaValueConstraint={trendConstraint.deltaValueConstraint}
                                sawConstraint1={trendConstraint.sawConstraint1}
                                sawConstraint2={trendConstraint.sawConstraint2}
                                sawConstraint3={trendConstraint.sawConstraint3}
                                constraintId={trendConstraint.parameterId}
                                settingsType={'trendSettingsIndividual'}
                            />
                        </Panel>
                    )}
                </Collapse>
            </div>
            <Form.Item wrapperCol={{...layout.wrapperCol, offset: 10}}>
                <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                        backgroundColor: buttonText === t("apply") ? "" : "lightseagreen",
                    }}
                >
                    {buttonText}
                </Button>
            </Form.Item>
        </Form>
    )
});

export default TrendData
